import { Box, Input } from '@mui/material';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';
import { colors, fontFamilyPrimary, fontSize, fontWeight } from '../../../../../theme';

export const FilterTableBoxStyled = styled(Box)`
    &&{
        display: flex;
    }
`;

export const TextFieldDivStyled = styled.div`
    && {
        display: block;
        vertical-align: bottom;
    }

`;

export const ConversationDivStyled = styled.div`
    && {
        width: 95%;
        flex: 1;
        min-height: 0;
        background-color: #FFFFFF;
        border-radius: 8px;
        padding: 38px 20px;
        overflow-y: scroll;
        &&::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 7px;
        }
        &&::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background-color: #A2A2A2;
        }
    }

`;

export const ChatbotResponseStyled = styled.div`
    && {
        color: ${colors.grey1300};
        font-weight: normal;
        font-size: ${fontSize.m};
        background-color: transparent;
        margin-bottom: 15px;
    }

`;

export const MarkdownStyled = styled.div`
    && {
        line-height: 1.5;
        overflow-wrap: anywhere;

        p, ul, ol, table, blockquote {
            margin: 0 0 10px 0;
        }
        h1, h2, h3, h4, h5, h6 {
            font-size: ${fontSize.m};
            font-weight: ${fontWeight.semiBold};
            margin: 16px 0 8px 0;
        }
        h1, h2 {
            font-size: 1.15em;
        }
        ul, ol {
            padding-left: 22px;
        }
        li {
            margin-bottom: 4px;
        }
        hr {
            border: none;
            border-top: 1px solid ${colors.grey400};
            margin: 14px 0;
        }
        blockquote {
            padding-left: 12px;
            border-left: 3px solid ${colors.grey400};
        }
        table {
            display: block;
            max-width: 100%;
            overflow-x: auto;
            border-collapse: collapse;
        }
        th, td {
            border: 1px solid ${colors.grey400};
            padding: 6px 10px;
            text-align: left;
            vertical-align: top;
        }
        th {
            background-color: ${colors.grey000};
            font-weight: ${fontWeight.semiBold};
        }
        code {
            font-family: monospace;
            background-color: ${colors.grey000};
            padding: 0 4px;
            border-radius: 4px;
        }
        > div > :last-child {
            margin-bottom: 0;
        }
    }
`;

export const ChatbotQuestionStyled = styled.div`
    && {
        color: ${colors.grey1300};
        margin-bottom: 10px;
        font-weight: ${fontWeight.semiBold};
        font-size: ${fontSize.m};
        background-color: transparent;
    }

`;

export const TextFieldStyled = styled(TextField)`
    && {
        background-color: ${colors.grey1200};
        color: #8C8C8C;
        max-width: 150px;
        border-radius: 5px;
    }

`;

export const InputStyled = styled(Input)`
    && {
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        background-color: ${colors.grey000};
        border-radius: 8px;
        padding: 10px 16px;
        margin-top: 8px;
        color: ${colors.grey1300};
        width: 100%;
        &::before {
            border: none;
        }
        &::after {
            border: none;
        }
        &:hover::after {
            border: none;
        }
        &:hover:not(.Mui-disabled):before {
            border: none;
        }
        & ::placeholder {
            color: ${colors.grey400};
            font-size: ${fontSize.sm};
            opacity: 1;
        }
    }
`;
